module.exports = __webpack_public_path__ + "assets/img/home_foot_qrcode.82dab155.png";